import type { Message } from '@/types/message'

interface MessageBubbleProps {
  message: Message
  showSender?: boolean
}

export function MessageBubble({ message, showSender = true }: MessageBubbleProps) {
  const formatTime = (dateString: string) => {
    const date = new Date(dateString)
    return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
  }

  return (
    <div className={`flex ${message.isMine ? 'justify-end' : 'justify-start'} mb-2`}>
      <div
        className={`max-w-[80%] rounded-2xl px-4 py-2 ${
          message.isMine
            ? 'bg-primary-600 text-white rounded-br-md'
            : 'bg-gray-100 text-gray-900 rounded-bl-md'
        }`}
      >
        {showSender && !message.isMine && (
          <p className="text-xs font-medium text-primary-600 mb-1 ph-no-capture">{message.senderName}</p>
        )}
        <p className="whitespace-pre-wrap break-words ph-no-capture">{message.content}</p>
        <p
          className={`text-xs mt-1 ${
            message.isMine ? 'text-primary-200' : 'text-gray-500'
          }`}
        >
          {formatTime(message.createdAt)}
        </p>
      </div>
    </div>
  )
}

interface DateSeparatorProps {
  date: string
}

export function DateSeparator({ date }: DateSeparatorProps) {
  const formatDate = (dateString: string) => {
    const d = new Date(dateString)
    const today = new Date()
    const yesterday = new Date(today)
    yesterday.setDate(yesterday.getDate() - 1)

    if (d.toDateString() === today.toDateString()) {
      return 'Today'
    } else if (d.toDateString() === yesterday.toDateString()) {
      return 'Yesterday'
    } else {
      return d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' })
    }
  }

  return (
    <div className="flex items-center justify-center my-4">
      <span className="bg-gray-200 text-gray-600 text-xs px-3 py-1 rounded-full">
        {formatDate(date)}
      </span>
    </div>
  )
}
